import { useState, useEffect } from "react";
import PageLayout from "components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import SettingsCard from "components/commons/SettingsCard";
import SuccessMessage from "components/commons/SuccessMessage";
import { useGetDevicesSettingsQuery, useSetDevicesSettingsMutation } from "./api/devicesSettingsApiSlice";

export default function DevicesSettings() {
    const [t] = useTranslation(["global", "device"]);

    const [settings, setSettings] = useState();
    const [statusMessage, setStatusMessage] = useState("");

    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetDevicesSettingsQuery();

    const [saveSettings, {
        isLoading: saveIsLoading,
        isSuccess: saveIsSuccess,
        isError: saveIsError,
        error: saveError,
        reset: resetSaveStatus
    }] = useSetDevicesSettingsMutation();

    useEffect(() => {
        if (data && isSuccess) {
            setSettings(data);
        }
    }, [data, isSuccess]);

    const handleChange = (key, value) => {
        setSettings((prevSettings) => ({
            ...prevSettings,
            [key]: value,
        }));
        resetSaveStatus();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        saveSettings(settings);
    };

    const content = (
        <div>
            {isError ? (
                <p>{t("Failed to load settings.")} {error?.data?.message || error?.status}</p>
            ) : isSuccess && settings ? (
                <form >
                    {saveIsSuccess && <SuccessMessage />}
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mb-4">
                        <div className="col">
                            <SettingsCard
                                label={t("device:setting.logout_on_removal.title")}
                                description={t("device:setting.logout_on_removal.desc")}
                                logo={<i className="fa-solid fa-user-lock"></i>}
                                value={settings.logout_on_removal}
                                measureUnit={"mins"}
                                onChange={(e) => handleChange("logout_on_removal", e.target.checked)}
                                inputType="checkbox"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("device:setting.low_charge_alerts.title")}
                                description={t("device:setting.low_charge_alerts.desc")}
                                logo={<i className="fa-solid fa-battery-quarter"></i>}
                                value={settings.low_charge_alerts}
                                measureUnit={"mins"}
                                onChange={(e) => handleChange("low_charge_alerts", e.target.checked)}
                                inputType="checkbox"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("device:setting.off_body_alerts.title")}
                                description={t("device:setting.off_body_alerts.desc")}
                                logo={<i className="fa-solid fa-hand"></i>}
                                value={settings.off_body_alerts}
                                measureUnit={"mins"}
                                onChange={(e) => handleChange("off_body_alerts", e.target.checked)}
                                inputType="checkbox"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("device:setting.device_returning.title")}
                                description={t("device:setting.device_returning.desc")}
                                logo={<i className="fa-solid fa-house-laptop"></i>}
                                value={settings.return_info}
                                onChange={(e) => handleChange("return_info", e.target.value)}
                                inputType="text"
                            />
                        </div>
                    </div>
                    <button type="submit" onClick={handleSubmit} className="btn btn-primary"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>

                </form>

            ) : <></>
            }
        </div >
    );

    return (
        <PageLayout
            pageTitle={t("Devices Settings")}
            bodyContent={content}
            onPageRefresh={refetch}
            isLoadingContent={saveIsLoading || isFetching}
            isLoadingPage={isLoading}
            isError={saveIsError || isError}
            errorMsg={saveError || error}
        />
    );
}